import {
    Button,
    FormControlLabel,
    Radio,
    RadioGroup,
    Stack,
} from '@mui/material';
import { useSelector } from 'react-redux';

import {
    ALERT_URLS,
    NamedURLtype,
    NO_SOUND,
} from '../../constants/sounds.constants';
import { RootState, store } from '../../store';

// PlaySoundButton is a button that plays a sound on click
function PlaySoundButton() {
    const alertSound =
        useSelector(
            (state: RootState) => state?.customer.details.customer?.settings?.alertSoundUrl
        ) ?? ALERT_URLS[0].soundUrl;

    return (
        <Stack spacing={2}>
            <RadioGroup
                sx={{ margin: 1, padding: 2 }}
                name="sound"
                value={alertSound}
                onChange={(e) => {
                    store.dispatch.customer.setAlertSoundUrl(e.target.value);
                }}
            >
                {makeRadioButtonsFromAlertUrls(ALERT_URLS)}
            </RadioGroup>
            <Button
                sx={{ mt: 2, mb: 2 }}
                onClick={() => {
                    play(alertSound);
                }}
            >
                Click for sound
            </Button>
        </Stack>
    );
}

// play makes a sound
function play(value: string) {
    if (value === NO_SOUND) {
        return;
    }
    const sound = new Audio(value);
    sound.play();
}

// makeRadioButtonsFromAlertUrls generates the radio buttons from the data
function makeRadioButtonsFromAlertUrls(URLS: NamedURLtype[]) {
    return URLS.map((URL) => {
        return (
            <FormControlLabel
                key={URL.name + URL.soundUrl}
                value={URL.soundUrl}
                control={<Radio />}
                label={URL.name}
            />
        );
    });
}

export default PlaySoundButton;
